import React, { Component } from 'react';
// import Prism from 'prismjs'
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SketchPicker } from 'react-color';
import { withTranslation } from 'react-i18next';
import { toastr } from 'react-redux-toastr';
import { v4 as uuidv4 } from 'uuid';
import { BotsCreators } from '../../../store/actions/bots';
import { UserActions } from '../../../store/actions/users';

import iconAttachment from '../../../assets/images/ic_attachment.svg';
import iconSendMessage from '../../../assets/images/ic_send_message.svg';
import Footer from '../../Footer2/index';

import ChannelBarFab from './ChannelBarFab';

import './ChannelWidgetHtml.scss';
import Toggle from '../../Elements/Toggle/Toggle';
import { ChannelId } from '../../../util/channels';

const botIcon =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAACaCAYAAAC6yOoUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQwIDc5LjE2MDQ1MSwgMjAxNy8wNS8wNi0wMTowODoyMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkE1MjAwREY5RDYwNjExRTlBQjA5RjUyNjg4NDY0Q0UxIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkE1MjAwREZBRDYwNjExRTlBQjA5RjUyNjg4NDY0Q0UxIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QTUyMDBERjdENjA2MTFFOUFCMDlGNTI2ODg0NjRDRTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QTUyMDBERjhENjA2MTFFOUFCMDlGNTI2ODg0NjRDRTEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz75Nld6AAAgq0lEQVR42uxdCXwURbr/qmcSAglJSIIkIZAhJBwhYpCAEDlWlFO5BBEFFVgFb33Pg3URj1X3ybre6yK6+0RWQEAFD3CBPBYQERCQ+w40kHCEEEJIQiCZrtfdOZiZdHVXd1f3TI72F+dguru66l//7/99VfUVwhhD4+FzFP4WBVfPxcCVgiiouBgJFcVh4C4LwUKFEwEW/0OAOGcF5pqWoqCwYnCGF0FwdAE0aZkHkemFjRXofTgb7JMX/BIPF3enQfH+VLh0KAVKspNxCe9C+Gqw1O8QgEvqfuIrYK83lYcENPF/gOXva77m5f9zTcogtB0PoUlHUfOOB3HzzvtQxPV7IPqmMw2xqlGDYLLSYxzk/9QHCjZmwoXNN+HCnelVmHEhhIFYBTXgInz2/bkETlT16vUZSZ95+fQWN26HqJs2o5jeGyFx4oZGkNXl4+zyNDi7ahCcy7oVF+1PFRvbJT0r8sSKLyhqMZcPpkggI3yvdn2EEC+/RnTZA60GrkZxg1ZB7JADjSAL9OPUVxlwetlofOrbEchdEiY+m0sLRDRgMQYi9e9rXx/x4IwoRK1HfAcJo5eihFE7GkEWMNrq5wQ4Of9eyP3yHrhaGCm2mMsaEOgHpZH7Vn6PeNQkJh/ajl+IXBMW1HUtV3dBxs8ZAsc/mwyFW3rKjKXWiCQQaWgs33+vPr/mM2iARaU89JpPZLiYzI2o/ZR/oqQpaxpBZsdx4JVJcOzvj8HV/Jhqc+gLAhqQqTIXc+HPAvQi2ELiTqGUh+egtJnzGkFmxbH3ucfxkfeeQlDhlL1CDTNU3WhmzF/1RyPmj6Xj4F0eEWxcSBnq9PS7KP3PnzSCjMWx/8UH4fCs6YArnGItuxRBoJdJVEBpHgTGtKABzSeCrWkZSp0+C3V9eW4jyIwcRz8YgQ++NhPJZhFcyI9MYsZxMOPNVl9fozyiGY0/ha5/8Q3U4ZEVjSCjOfJWdoL9L70Khb/2rPEU9VV64JhPEuhMaj5lDSqa0Zaig5AudsxWtxxtBBnp2PnwH4D/ZBoGgrfI1twELHMZMbvXOpEIto6Pf8j1+OCdRpB5HrmLe8LeZ96GyzkJ4ieXVgjBjPfIgknMeI9mvFkdGpRHYUlHUcbbz6A2/g/q+h9kOx99HviPH5FMY90Nnpq7L0vHwbs8iOc6P/k+6vHeew0TZAUb42HnI7OhaFfXGvayoNIbzafoGERlbEW9Zj+CojPyGw7Ijn10B+x64kPi2KJFwVPDIQ9GIwbETmTpiMG1YC7X+5OHUMqDWXY3N2c7wHY9/qwEMMk8InStt3u2PiJ2CY+3yPsrpHQu8n6PCJdDStdEGr3T55q+5aHq4UDxDCbPvfYZu4SNUz/FW595sn4z2S9DZ0Pev4dUm0cjPdeSsUebzLGZEAwLDVodV0NtRn7HDVj2VP1isqLd4bDm+u9rAIa9K0Kz53r+BlP0eqz8HmkTpGEW0nOOmWswuL8Ln/h2hPB9xtdQdCi4fjDZ+XUu2HLXErh6LiPgg6d6RwxMBU/9H/KAZgkbuFuW3IVa9jpTd5lMmp26cfBKCWB0ukF/r0cMmMPI/X01mdJFal1DhwZFNmhQXJrTR1g1eCU+lZVcN0F2elk6/mX49yBc6SD3RFzVwbAPM8C17z17pJfuAsK5WPlcz57rda4Ho3jdCwjnKpQHa5RHqWyYUB4glMfrNz7lwYTyKMkErFEe+U15UVf3qmE/4pwfU+sWyM58mw5b7lyKqsYezWgOM/rJCPtZcn8GGhSs1KC4PFnIGv49zl3ZqW6ALG9VB7xp9FI5gk9iClKvJzEFqdeTmIvQ60GlPIrnAuFcrPwsmswFZPbBGiysdi4ARR2CCnPKz+9OcmeNWorPrHMFNsgubIqFX8d87ctg1sR9/B13sub+YMP9kcKJ8nfusk7CmrFLcMGOyMAEWclRDm+5exFUFKeRerQatWMNNlBiIZK202ISUGESbIZJSExKuq8BzadLg1LUYS39VpafIawR2zEgQbbt3oVw+UQ/UxpMRYsox1+UdQxS0TqgoXUQ5e9Zxa5Y6EeW95cf9eKhDu7lv/s8sED26/hZULC5J8mr0fTWtFiP0IuJ7EPQTETmInmeJBYjeXoWa1BMq0HNM6dL1Gb93OsmvRoYINv/0hTIXTQOPOaBIVS7i6hqDoUxQNXehgixKhXNQSoPKf6ldC7xGTTKAyQNpBL/MqLbGGtQFz78+f3CjjcmmoWIuYh/7qJeIostFK/g8t/qnYCbc2/12KPN898Q7xi4bCRKHLHLfiYryXbCjodnQxXA7Iw7GbkGi3HDhjn2iV3uDdPm+Mdc7nzsI3y1MF1RA4F2xBp0RKytGDHA/hwxUIrhYQoNiil0pBUjBqVnYt2rRr1vL8gOvj4R8lYOImkXYq9DBF1lQezKr3EnuzSoyvw3rfqnmf/mUbbKmRu73h5rjya7sCkWr838BaGqOfkQ2HPuDZcnKAIwQvT3xQLg8iJ71n2Cv5bgId455rduKPoGXdkk9Wda3PP8W56Zc9R6odIzILqQExPNgdW+F0GEWt0G0DwFoGksQEgcIOm1aZz8Hpyh+m9aUQxw+TRg8Q8unxHNTNXrpcOAT60CKC9m8vzIcw4Ppnh+j98jTHF/7MF62FufCZufe8sxbNVD1jHZ4b+Mg73TZynloqDqof6ecx+WAih+GED8UECxg0xKd9rDIwVo7o+VfznLAYqPmV/yB35ZMc9zmR88xaU98R17kEkpMVd3PCiN2NepJWsRXQASxwOKE8HVopsNoKIDHT6/FSBnBQj8QoDCgyxBYH0IJ6j5HufkouvZC//9L7+KhfJkO+c7YRXvEbS8x2YuQBmzAQ3dDSj1RRFgN1bVoD8BBjVlQNE9AN3wMjhG7geu5wcAzVrr8h7BYP0zmf929VKYe/3UP7JlsrysZPh54OqaoCtYvGTNDHMFtwDoPB1Q5+cDAFB6CK4C8O43Qdg9S9ZugST8CfKFd4zc0BfF3pzDhMnwwddnYs8FIBaNPYLKrAmaGRco9Y+AhvMiwKbXLYDJaHAC6voiOMaK5e/yHJH99dY/1lH/Osd+Xe7tr89gYy6loaP8df0Ces59VHfgJLPY9XVRL4RDnT6aRAPXYxZww7cBapFGrFAj45asxz7xiX8Pwfx3Xc2by//0WIIvbB1riffCYPUOajsOUK950gYN5hu4/BLA1QJRc1wAJP5h9xX1EIxngR0hIkBaVJpr6S+oOYPyFIGw/n4Qjn8bsEn7uLi+XzhGrr/POMhyFmbCr/fOrxWyIAU7bUz0Kxc+9QWRvd4wZhorSgAKtgEu2ArooujdiaACoVxBUesU9dW/54JksOGIzoBiMgCiMyqBaMAbFbY8C3jvO+wH3NkkWua5wUtHc+3I2YNUQYbX9l4IBZvGAyvmYuhyo56fAkr6vT6AXTkHkL9JBNZ2QBd2+IgTzTCX3rCYz2cEOLqb6FV2B2iZKbOeLqAdmA3Cz48F5KwVFH/LXOeINZP1g+zMilS88fbllTt5+Dnfl+f3zuaA+n0LcN0tOlirFPDJrwDlLPXxIsBGkHmLfJx4J6DEMSK70Zt5nLsShNXDRTNeziABi7nFx7750ESQ3YpaK2d4JAv/Y3OmAVQCzE/ei/J9e8/TB7CTXwNseQjQyW8qL+J7X0wACtYBMN2/rwDELwbYOBXgxDJ6Y9x6MHD95tWuH72rp0gzVkgevrY36xL2yXjRwWRFe8MgK22352TEQMj3hbr9FVDHZ+haJG+dqBbmiyYyTx9z6WUvndfCPh6c/LlpHKD2E8XOczPVLYWdb4Cw9cVAm/TJOydkt0fhSQIdkx2fO6k6LkYTIQZChJgqYk05VwolP0oPsOOLAA68C1CWRwcYbICNWF1L+k3pacC73xKb6Wu6YZobZgCXMkU56g/WrJinGDFwCQfmTqI2l/jEvPtsi7tQzLlHcYMBZfyNro0PvieCbGEdifL7fMz+F+D9H9EBrd8/xHrpr17/evOtmYyDCgfnPUAHstwlPUUGuM7q1TuYdvVOWDKgXnO1a6nsDOAdLwA6u5ZON+llG9KfmWspHadWA942UzTz5zXDJY7+nwOEJpDrH2vrNqYr+IuOt8XHf0jTBlnO4rvAMwO1DvTToF13z7lRZKaQWO0g6p7XABXtN+7xMdJcwOLShbvFDvMagPuK+gXCEsHR6x3NOtTTlibXfbqEw4vv1gQZzvlqrGIt+GHOPWp9B6D42ylMpKi/SnMD0gqSJJomNot5wHvf1W7YdiInxN+qyEK6Zq1QrMHAFHgQsr8aqw6y4/P60cz5rjVfnIR+hfxaqj3HZ/565UC3RoNmfwqoYHugyixzrHduE+DD2gu5HenTleuUYg0Gy3xr8mvF5RARaBlEkOHTPwyvmW1hc74v33NR4gSAln3Uazf3e0C5y+3XTSyvpaX/ji8VrctKjfjZQECuO1VXkLPMt6aBB5dw7PvhZCY7s2KYWg+sla+C1l5o6Tel32ux2EVRf2X/k42uYkZVFl37wGxRVGere5vpzzPRwFTX0Mi3ho974+gayM6u7gAVJc2MZIlR8zx1Z5iBypgYRKrP7sUnvwbbDh82wjbi7lqoU/15UcubgOswWb/3rqLfjOZMw5fzY/DpDQm1QXbu/wb4epX+yveFOj2tfnFp5oT4ZwtTYROOKsty5W0EXLBbnc2uf5pp3MvENVzCyTUDaoEM563rb+mce1rvJSazcpmaFoupaS4jUXerYmgsNZsWm0V3BRSVTmYbO1fw5669pTaTFWzqFQh55uUla6o9ej2gi/sh0A5MwA5TfXd+h0gGm9XrsO0w0zFMFrEz0Vz28QbZ2coU23pmTajOuTeR70sTZDnLbAEMNoAFbAaVtAXil2qDTKX+adZgGMo56/sbd7kTn94YXwMyfGGLlMDOxTzPvV6bL5nJmrWRCoe0Mrv4KFvlTXktzFJzmSnvxQMAVwrIdRp7M6DQeGK+NZrcG7rzrSnjwSWclXFVxWQXtnfX6wFig5mXFW159aHFYtKC2EAfe2R5nhKlSnV6bpsmm1mZPZw2moDzRFzVgKxwZ1e9NhfpjIfRxFe0TCUu2BawGszW2Nq5rRogu93QZVlrcJxfiatKc3npSLKSbdYzawJ0xF1Img9d15f8FBUlVfPyA0vcW6K9tBjv/DZJ9JBDGXF9VEdsNL1Hldkaes7F+XvSKkF2YVsMQto0RhpjRIjC89AY85Rfm8QAOJqqxMa2sQtLmA1x+IPBPK8lVIgmU4XNQsS6dDY1rqN14EE13xoWOFywvxkHxUekBCouVtmiDXsvUsomtePyWYsphxFQWMbJ1DpKqXp9oGZxTLOHG4wmuHDhkWQOSo4mWR0zobH5cm4wtbaQ1kXaELbAemNddhRE6biiUR/N4qhjZJbm3C06msThkhNtid6CTVli5NcQDSa7WuD3OFhAeRManU5iskDYpQ5fOtHWCZdPxZGQi5HH6hWlZfI6mUsV/RrmEmkxmVkTabdJpb0GNshkobHa9e+7BoC0nlYBD4ppK3zbTMJM8ak4DsrOxKqykI754tQ7ZiihX8NcwpXCRoB5/lOZOrMjsdMym8ms4nmq4kF6LTkTy8GV/BhWMRNTY59BkfrMA6slbFbqJqAQeNgYeNFVjdzATSLI9U+hFViNfUrTfjix8aKIngZlnnvN2ImK5gssUeTHsIQF96AZdQEN3UaTOw5I52LZrEc5ofxSmKcN9npVsMGqzEWw8UhF85lmAqNBT/DT77EN4DVgSRTbH/RlL1eKt0mpPznAFc5A2GO73hzYz+yoYllAi4WsiCaUl4RxZm2u/Mpwj22r2trvcTC9moylHmTMerqugd0cF2h7bFvBHthuZgoUs01iLpv3G3WasrkGbD5JA1jaQIGkwXBggJ1Wg+mJHpDwwAXMHtsNiV3sfl5G+7UbnUPI6XkQv+Za0NAimFUsi2UMDTMGmJHZI0q6GYztuU6KtyG1ukMOQQQZJ9RCqp/22GbWHoHi4fmRJVmuwdAasVHN2uRsWsqhoPAiTZtr0x7bzBhEL9sYTSFgV2pQAx2RtK8oaR9MJbqinW+mugYkOLyIg6DIQiZjj2a8F8ZMYutAAg4M5qp1KQM7llBHE3TknEVNIgs5aBKTr6WPbFl3WV6k/u/BEYbjY345WA2cY2MTeq2e/0fNpCEx+RyEtMoLhD22sbT5qFobBLeoO3oqADxU0ogNiz3XQQUPvuei0FZ5TmjaOtfoHtvEuJfCPDRN3SCtqVQ7fDdX8GejYwvvwQhwiNBOepiLxdgnhLXO5SC07QkmK4bNei+lGiBTYTJbTaLNADMdIrMo5y9tNAE1b3vCCaHtjlqyx7fenqNhLpEPyPyitSwGmN3PxDr3ieKsjYh2RznUPPmI+CVvRZYePSMGWIvJQlraE2DFgcFgTMIuDHdKxsbwwKPI5CMcRPfMY5lj1HDOWWljh5pd2hSO6O7GYllGYlNqDco6NRS2oKNo1D8o1b9KjK3WuXrwEJNWXDmsFNqOV/QcDOQY1ZzzrbZ+IO9n1RAGjkzz24xrlo2NsccfWDzlyKacv0p4QNGp+6S3lSBr0XWXVkV6IdZgEFXL5uOTK9QvENMd6vqBsf86BynnL80aAL05f+V/a3nDrhqQoagbt4EFWXr05pzVApm8OSkLnWJ0aEhPoyqdw0J76SiLmby9WjMugAIPXKsbt11jsugeUmIF3mzMxGyuBVy4V/4jHqFtxL+2xk2XHfPrrdReBscvzeT81bJCKtfiUayMqyomix+6j9WKYSrvRS3upmUy246wXk8Zna5jJYgNeLJ25/z1xQPXpj9/jclkk9l9u9mYCYtcCzhHw2TG3wbQPNkvgr3OAIxR3Esnc3kdXEKfDTXva05u1X9dLcSCxTlGFTxP4fRagJKT6k+QeKc5XcQy26LWPViU0yDwDO+UzCBrE0qoxJMXyCB2wBrZjupAruFc/Uh9vpOw9331XtYqEyDqev+wDbaBNRndw4p9FyivwXOJt66pzWStb98DKKjC1IphWg9EI3OjsPttwJeyNdhsTADGJ8hERy3vMAXr6SkO4xXkNNEEaBJexLW9tum917pL1HroCiNzvk3NNyJps52z1M+PTgdIutd/GkwFYIYZy4+LnanaUivnbzWokoZ5CWtvkCUM/15EI697zjcJlCZGDIQDnwI+/5t6xSSNA4gboKxhaIeGrNRNLLSg2TSkWp4/+6xNPNf+juVkkKU8mGVozjcFXSFEca6PVhN2vqndA7s8CRCZ6jfmstS7xeyZyreeqdZgEPYyV25Dh+BInbCBCDL5SLjjB9M5RkksiCnGzTzfZy8GLHmbmkB7StQBUfRs0pAApsRCJleQq1kjruOYr2qFM2o1mOvuRVAV/Tc830hl7EuvfhM2PSPtBqv+o6atANJnmBsNsEI3GfUSMXvQ2bTXEu/oNG6JNsiSJm6AqmVydux3qeaFyh0ofzu41z6gXQHh7QH1/B+AmB50sSyWuslMfE6rg6rpTK0YmU05f2v2YQiNPcN1GLNVE2Ryg7W//19mo74sxz7xsSUgbHlB+6bOUEDdREZrOxzq5KGHrbgg7fpX0V4kraao2yjb0JF2378Ui6pYwORJcyUvwXCOUWCfuVHY8abscVLReqffA3SeKj51iGVYMLPFpV4PVfE+ES71y5adp/IesZldR7zbj3ekibihBll093wUPzDLCHOZiaFp6Qb3+mmAT62hu1bbYYD6fwLgGmWORbAOssGMvleKu/n+Nryd+uPk7TAcwzTShlzKyO9QTGopNcjkC3ecNkdiMxLa/ZNrAYP7P/cDPk+5x1JQuPgckwD1/Vj0mgdR6yPSzFVMw0RGtJfvPavvS7qGyNAocZC6w5S3UzG2RT1nTF8clHekT51DBCARZIljtqKoypmNyARzMR/7LMmFimV9RJ2mY6P7ZrGAujwK0PttgKRxgMOTwK+HyUg/SpsCqFkr8uUvi6by4lHDGpi0BxbpAlzrXpu4pGH7dINM/sfUJ9+v0WYGvUeasS/dmRsrSqBi1V2iTvuLvsaRPNCUe4HLfBtQv9mibntQ9Ea7WabdmAOseQJwvV4CToPF8IksXTl/iW1KFwflHd2f+FC13rHGpHP30i7LceG+YajqZl47k+DaK8SRr45APgVUWZipdn3FFcoYgSN1KnD9Pjbf8iJwcdmFyp0+pD/xPXZf0cxI6Pu8aivmqQCoVD8iayFR6KPwRCqFVP71EBD4lYbr39MpUK9/kYhiu38TPGmr6mwFp6agS3vuLfdPk1PF67m87DUiMBci2G5U9YK9C+n5EL6/V2Q95NlDRY22bw4IF7PBMWAuoNDWxiWuMwxQWBhAWBtqc84iqQnrw/3bhyAcW6la/6RO7elVIkL9g1f9iyx207NvaWJIs/pTJq1FLXtspdrfUMN2I434Cyleo9XAODcLKhZ3BWHn29CQD3x+n+gY/bfpCACtBufa9Fvv6Dx+k2mQyT+6YcYb1avMjXiPtmRuLCsA98bnoGJ+Cgj7/tEgQVYhAgwLFcp6z+SuIwq/4Z2ZM96gwg9dzGnkDi7xzm/Mxr2smHPuK2pw0RFwr50KFV9lgJC9pGGgS3BD+fKJlTpMVYB71CGmMO8qOWcdqRMWcO0GHaJqO0ypUvGF3eHub7pKwRcXSajWEo4KQpFW2JtxHK6VB4nudX/gUsYDShwmaq429Q9fIrBkBhNNZa32AI16VvlesZ5rtDLim0w7lIJaJFcwBZn8QNtfnoJ/+9PMaifADu9Fy5tV9c48E6ZJb2N7i+7/0ErAtbyxjtvGy1Dx8ysgbH0LMMZU9U8iBZ31zzv6/3mGs/cLC6itENbpb7uXdVuK83eMUio89pmSq6cHqYYAtHqWTx37lsf7vqjS9Y5oD9BmIHCRyZVbKYfGAZKCtuIrbepQW4/yYhDydsjDRThvF7gPLJD2LWJW/6qd2KOeuda9vwy+f+M9uqSOXpDhU1nJ7hUDV6uZTSJzWUXfhO/pKh3V/j4oFLhm0l6znA2gV2ESj1d84bBPhRgvj4n654Pv+6kvl9Anx1KQyWbz1z88LOycNV081aUveOrTUwybP3aaz7c8RsyNkfKwDF7bJD94Z59XXnX2fXmuXrxwRpib6/Hmx6hV5kZSjgvSXPBa3qLKGgDFc/XOdyKUh3gfg/nWSOXRG3eiCfSyinuBzvtziQPWGAGYYZDJJ2b+7QlA3FGz+11alblRMe5jxR7betYtkGJRFu3axiznb1DovqDBHz1mGCtGT0TR3Qq4vnOmSTSK9OYrw4S9Mkm9jpT/inSOjXtsm2UOFvcHBvdXYU4+aOjH01B0pzLbQSaf3PHBLC7tqfdrcs6qNLKZvTL1RqxZR7uBdC7DTIWK51q4UzLlGgDe2Wv6LEeXiRtM4cSsZ831fu89rs2Qf4NPfjO9Nt8Ic1iR60HX/DcVzVcPNCjPdRy1zHnLm2anuBjzLhVjg4tTf8QX9g9hEzz1CQGQQhAGvFk93qMV3qwe75FR8NSQN8vFpi8LnvLbaBbY4IDR4bh1/gQUHLFLr35hpBsM6ye7rqGLOa3WoCpjkvJ3oa22BI1cMIEVNpiBTHIEHAMX3Q3YY7YGaO93aSDXAvtd6syumGeU7wsHggblgo4EjV50N4ruXBpwIJOBljD4gAw0jzxngRr3MXJ/VA/v7/OZD77zqzFc2/48S1wwBZlc6KRxWxwDPn8AV690AjC1gtzEfCfb9tim8R5tnHOvx3v0LA8fNPrLe7iUEbtYY4I5yOSLdrh/veOWzyaDQuZGdS9EXYuoaRe/7bHNUD/6cb9RPmjUwnscne/eZAUemHmXSodweH4fd9ZEaem6S9VbMzFgruotaXzPYpaC9QP4ls9a4YPuXHKXo9PYrVbhgAMLDy5lwgbn0GWjJTGp2ts09jjXm3NWLT7FfI9t3xgWomAhPfm+wMKxz+CwPcHjfxxqJcAsZ7KaDnT6p7buVfcsxCW5mayZxAiD6Z56Y/H8Nz8wOY8ik45KJpKL75lndfvbAjL5OS8ecYqmcz4+u7lno/m0yXwq34+XVhkF37fuAbDp4Oy6EYpIrnCO2XQ3l3LvAox9Vj6RhDmrXer8461pZyrUkWmH9BvVc2s/A+/oOvkzOwFmK8iqD8fA+TMcN702U+xhvB/zzNsVdzKkQcEaDcoH3TpretAd//snu9vcNnNZy/Pkf0hzr31kNpTkJMgzbCnNgRHzF9jTvy3XoJX6a+jsR2iXsNUbkFUf7pXjZ7kPLxon1o2rLgp/I/e1UYPyjrT7vggaMW+mP9vY7yCTWW3P7GHuDc++hctLUxvn3DOZtcKjJpGFztv++pzjht9n+bt9AwJkcgUVHePcP0+fhbOXjK2v5tMKb1bh+ryjy4QFQSO/mAEBcgQMyGpY7dCCTPeml17DF7OTxEpzWZt6yprVU7rLwyYEw6PoTgec/V+baXVwtc6DrEarbX5lknvLn15GUn4LTFixbiFz+TvupYe5wBF81dln5mvOm1/8IhDbMmBBVgO2/zz8B/euOdPESnUFavDUjyMGvDPj8Y+CBn3410Buw4AHmVyZ53eHC9vffdq9T57Z4apDIDC2glzbfPKOblM/dfb8r3fMrCJqBJkS2Ar2NxN2fvSoe9ffH5NaQkr80lDm3NeYxRsfme3IeOzvqEXK1brSbnUKZF5m9Nc3Jgp7PpssOwgeqUbrYdoEHkV1POS4Yco/nb2eX1wX26rOgqzGG83+Nl04MH+CcGjJ2KpGcwVy8JTyvrz0Pdf5ni+daffO55Lv2FOX26jOg8yL3XZ9PAQfWTraza8aVNXYrjoU9+Kl/znaD1vBdRj1rSP9oVX1pV3qFci8GG7f3N+5j60ajE+svg2X5scoeacBEILgUWirPM41cBWXNGi1I+2+9fWxLeotyLza9MyW64Tc9f2E3F9649Obe+Hi3PiqxnbZKPx5+TWiTQ4Xd9MmLiHzF9Sm73ouNiO/vtd/gwAZUcud250G5w90FgoOdoCL2cnC5QuRVczl0stcHsK9EkxNowtQZPsjKLrDIRTdeT/X8vo9XPLwXQ2xrhssyIisl787HBefjoXSvOtwWUEUXLkYia+WNAN3WQi4y4NroMYFXwVnSBkKDi2G4IgiaBpVgJpdl4fC4k6hmLTixpq8dvy/AAMAHHwWbZQz9KkAAAAASUVORK5CYII=';

const nameMaxLen = 28;

class ChannelWidgetHtml extends Component {
  uiInitialized = false;

  code = '';

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      nameRemainingLen: 28,
      picker: '',
      pickerColor: '',
      channelCopy: undefined,
      copySuccess: false,
      tamIcon: 80,
      isChannel: true,
    };
  }

  componentDidMount() {
    const { retrieveBotRequest, match } = this.props;
    const { botid } = match.params;
    retrieveBotRequest(botid);
    this.initializeUI();
  }

  initializeUI = () => {
    if (this.uiInitialized) {
      return;
    }
    const { bot } = this.props;
    if (bot && bot._id) {
      this.uiInitialized = true;

      const channel =
        bot.channels && bot.channels.length > 0
          ? bot.channels.find((i) => i.channelId === ChannelId.WebChat)
          : undefined;

      const headerName =
        channel && channel.settings ? channel.settings.headerName || '' : '';

      if (channel) {
        if (!channel.settings) {
          channel.settings = {};
        }
        if (!channel.settings.token) {
          channel.settings.token = uuidv4();
        }
        if (channel.settings.mainColor) {
          this.setState({ mainColor: channel.settings.mainColor });
        }
        if (channel.settings.secondaryColor) {
          this.setState({ secondaryColor: channel.settings.secondaryColor });
        }
        if (channel.settings.mainTextColor) {
          this.setState({ mainTextColor: channel.settings.mainTextColor });
        }
        if (channel.settings.secondaryTextColor) {
          this.setState({
            secondaryTextColor: channel.settings.secondaryTextColor,
          });
        }

        bot.channels = bot.channels.filter(
          (i) => i.channelId !== ChannelId.WebChat
        );
        bot.channels.push(channel);
      }
      this.setState({
        channelCopy: channel,
        nameRemainingLen: nameMaxLen - headerName.length,
      });
    }
  };

  onBotFabChanged = (files) => {
    if (files && files.length > 0) {
      const file = files[0];
      if (!file.type) {
        toastr.error('Erro', 'Não foi possível identificar o tipo do arquivo.');
      } else if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpg' &&
        file.type !== 'image/jpeg'
      ) {
        toastr.error(
          'Erro',
          'O arquivo precisa ser em um desses formatos: .png, .jpg, .jpeg'
        );
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          const image = new Image();
          image.src = e.target.result;
          image.onload = () => {
            if (image.width !== 80 || image.height !== 80) {
              toastr.error(
                'Erro',
                `A imagem deve ser 80x80. A imagem escolhida tem ${image.width}x${image.height}`
              );
            } else {
              const channel = this.getChannelCopy();
              channel.settings.botFab = e.target.result;
              channel.settings.file = file;
              this.setState({ channelCopy: channel });
            }
          };
        };
        reader.readAsDataURL(file);
      }
    }
  };

  readFileAsync = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  atualizaBotFab = async (blob) => {
    const img = await this.readFileAsync(blob);
    const channel = this.getChannelCopy();
    channel.settings.botFab = img;
    this.setState({ channelCopy: channel });
  };

  onTitleChanged = (val) => {
    const channel = this.getChannelCopy();
    channel.settings.headerName = val;
    this.setState({ nameRemainingLen: nameMaxLen - val.length });
    this.setState({ channelCopy: channel });
  };

  onOpenColorPicker = (picker) => {
    const channel = this.getChannelCopy();
    if (picker === 'main') {
      this.setState({ pickerColor: channel.settings.mainColor });
    } else if (picker === 'secondary') {
      this.setState({ pickerColor: channel.settings.secondaryColor });
    } else if (picker === 'textMain') {
      this.setState({ pickerColor: channel.settings.mainTextColor });
    } else if (picker === 'textSecondary') {
      this.setState({ pickerColor: channel.settings.secondaryTextColor });
    }
    this.setState({ picker });
  };

  onPickerColorChanged = (color) => {
    const { picker } = this.state;
    const channel = this.getChannelCopy();
    if (picker === 'main') {
      channel.settings.mainColor = color.hex;
      this.setState({ mainColor: color.hex });
    } else if (picker === 'secondary') {
      channel.settings.secondaryColor = color.hex;
      this.setState({ secondaryColor: color.hex });
    } else if (picker === 'textMain') {
      channel.settings.mainTextColor = color.hex;
      this.setState({ mainTextColor: color.hex });
    } else if (picker === 'textSecondary') {
      channel.settings.secondaryTextColor = color.hex;
      this.setState({ secondaryTextColor: color.hex });
    }
    this.setState({ channelCopy: channel, pickerColor: color.hex });
  };

  getChannelCopy = () => {
    const { channelCopy } = this.state;
    if (channelCopy) {
      return channelCopy;
    }
    const { bot } = this.props;
    const channel = bot.channels.find((i) => i.channelId === ChannelId.WebChat);

    return {
      channelId: ChannelId.WebChat,
      settings: channel && channel.settings ? { ...channel.settings } : {},
      isActive: channel ? channel.isActive : false,
      isNotificationSound: channel ? channel.isNotificationSound : false,
    };
  };

  onChaneActiveNotificationSound = () => {
    const channelCopy = this.getChannelCopy();
    channelCopy.isNotificationSound = !channelCopy.isNotificationSound;
    this.updateChannelState(channelCopy);
  };

  onChannelActiveChanged = () => {
    const channelCopy = this.getChannelCopy();
    channelCopy.isActive = !channelCopy.isActive;
    this.updateChannelState(channelCopy);
  };

  updateChannelState = (channelCopy) => {
    this.setState({ channelCopy });
  };

  updateChannel = (channelCopy) => {
    const {
      updateBotRequest,
      bot,
      match: {
        params: { botid },
      },
    } = this.props;

    const payload = {
      channels: bot.channels,
    };
    payload.channels =
      payload.channels && payload.channels.length > 0
        ? payload.channels.filter((i) => i.channelId !== ChannelId.WebChat)
        : [];
    payload.channels.settings = payload.channels.settings
      ? { ...payload.channels.settings }
      : {};
    payload.channels.push(channelCopy);

    updateBotRequest(botid, payload, true);
  };

  updateChannelDomain = (val) => {
    const channel = this.getChannelCopy();
    channel.settings.domains = val;
    this.setState({ channelCopy: channel });
  };

  copyToClipboard = () => {
    const textArea = document.createElement('textarea');
    textArea.value = this.code;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('Copy');
    textArea.remove();
    this.setState({ copySuccess: true });
    toastr.success('Mensagem', 'Texto Copiado!');
  };

  tamIconFunc = (fontBalao) => {
    const channel = this.getChannelCopy();
    channel.settings.iconSize = fontBalao;
    this.setState({
      tamIcon: channel,
    });
  };

  render() {
    const { i18n, bot, user, match } = this.props;
    const { botid } = match.params;
    const {
      channelCopy,
      tamIcon,
      isChannel,
      nameRemainingLen,
      copySuccess,
      mainColor,
      mainTextColor,
      name,
      secondaryColor,
      secondaryTextColor,
      pickerColor,
    } = this.state;

    if (!bot || !bot._id) {
      return null;
    }

    let channel =
      channelCopy ||
      bot.channels.find((i) => i.channelId === ChannelId.WebChat);

    if (!channel) {
      channel = {};
      if (!channel.settings) {
        channel = {
          channelId: ChannelId.WebChat,
          isActive: false,
          isNotificationSound: false,
          settings: {
            mainColor: '#FFAA00',
            secondaryColor: '#D6DAE0',
            mainTextColor: '#fff',
            secondaryTextColor: '#515f75',
            pickerColor: '#000',
            headerName: 'Nome',
            iconSize: tamIcon,
            botFab: botIcon,
            domains: '',
          },
        };
      } else {
        if (!channel.settings.botFab) {
          channel.settings.botFab = botIcon;
        }
        if (!channel.settings.mainColor) {
          channel.settings.mainColor = '#FFAA00';
        }
        if (!channel.settings.secondaryColor) {
          channel.settings.secondaryColor = '#D6DAE0';
        }
        if (!channel.settings.mainTextColor) {
          channel.settings.mainTextColor = '#000';
        }
        if (!channel.settings.secondaryTextColor) {
          channel.settings.secondaryTextColor = '#fff';
        }
        if (!channel.settings.headerName) {
          channel.settings.headerName = 'Nome';
        }
        if (!channel.settings.iconSize) {
          channel.settings.iconSize = tamIcon;
        }
      }
      this.setState({
        channelCopy: channel,
        nameRemainingLen: nameMaxLen - channel.settings.headerName.length,
      });
    } else {
      if (!channel.settings) {
        channel.settings = {};
      }
      if (!channel.settings.mainColor) {
        channel.settings.mainColor = '#FFAA00';
      }
      if (!channel.settings.secondaryColor) {
        channel.settings.secondaryColor = '#D6DAE0';
      }
      if (!channel.settings.mainTextColor) {
        channel.settings.mainTextColor = '#000';
      }
      if (!channel.settings.secondaryTextColor) {
        channel.settings.secondaryTextColor = '#fff';
      }
      if (!channel.settings.headerName) {
        channel.settings.headerName = 'Nome';
      }
      if (!channel.settings.iconSize) {
        channel.settings.iconSize = tamIcon;
      }
    }

    // this.initializeUI();

    this.code = `
<html lang="pt-br">

  <head>
    <meta charset="UTF-8" />
    <link rel="stylesheet" href="${process.env.REACT_APP_CDN_URL}/cdn/webchat/webchat.v2.css" />
    <script src="${process.env.REACT_APP_CDN_URL}/cdn/libs/showdown.min.js"></script>
    <script src="${process.env.REACT_APP_CDN_URL}/cdn/libs/axios.js"></script>
    <script src="${process.env.REACT_APP_CDN_URL}/cdn/libs/socket.io.js"></script>
    <script src="${process.env.REACT_APP_CDN_URL}/cdn/webchat/webchat.js"></script>
    <title>Code7 - Boteria</title>
  </head>

  <body>

    <script>
      window.renderBotWidget(
        '${botid}'
      );
    </script>

  </body>

</html>`.trim();

    return (
      <div className="row linha-conteudo">
        <div className="col-md-12 conteudo-iniciar">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-6">
                <span className="channel-title">
                  {i18n.t('Configurar Webchat')}
                </span>

                <div className="card" style={{ marginTop: 8 }}>
                  <div className="card-body">
                    <div>
                      {/* Tabs */}
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            role="tab"
                            data-toggle="tab"
                            href="#tab-1"
                          >
                            Setup
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            role="tab"
                            data-toggle="tab"
                            href="#tab-2"
                          >
                            Publicação
                          </a>
                        </li>
                      </ul>
                      {/* Tabs Content */}
                      <div className="tab-content mt-3">
                        {/* Tab Setup */}
                        <div
                          className="tab-pane active"
                          role="tabpanel"
                          id="tab-1"
                        >
                          {/* Tab Setup - Nome da barra */}
                          <div className="row">
                            <div className="col-md-8">
                              <div className="form-group">
                                <span className="label">
                                  Nome da Barra Superior
                                </span>
                                <span className="label italic">
                                  &nbsp;&nbsp;(28 Caracteres)
                                </span>
                                <input
                                  disabled={
                                    !!(
                                      user?.selectedCompany?.claim?.name ===
                                      'Viewer'
                                    )
                                  }
                                  type="text"
                                  className="form-control setup-input"
                                  placeholder="Demostração Widget"
                                  defaultValue={channel.settings.headerName}
                                  onChange={(event) => {
                                    this.onTitleChanged(event.target.value);
                                  }}
                                  maxLength={nameMaxLen}
                                />
                              </div>
                            </div>
                            <div className="col-md-4 title-countdown">
                              <span className="label">
                                ({nameRemainingLen})
                              </span>
                            </div>
                          </div>

                          {/* Tab Setup - Icone e cores */}
                          <div className="row mt-3">
                            <div className="layout-canal-icone">
                              <div className="row ">
                                <div className="col-md-3 pl-0">
                                  <img
                                    className="setup-icon"
                                    alt="Bot fab"
                                    src={channel.settings.botFab}
                                  />
                                </div>
                                <div
                                  className="col-md-8"
                                  style={{ paddingLeft: 25, paddingRight: 0 }}
                                >
                                  <div>
                                    <span className="label">Ícone</span>
                                  </div>

                                  <input
                                    disabled={
                                      user?.selectedCompany?.claim?.name ===
                                      'Viewer'
                                    }
                                    id="acesso-imagem-file-input"
                                    className="setup-bot-fab-input"
                                    type="file"
                                    accept="image/png"
                                    onChange={(e) =>
                                      this.onBotFabChanged(e.target.files)
                                    }
                                    ref={(input) => {
                                      this.botFabInputFile = input;
                                    }}
                                  />
                                  <button
                                    className="btn btn-outline-primary btn-upload"
                                    onClick={() => this.botFabInputFile.click()}
                                    type="button"
                                  >
                                    Upload de Arquivo
                                  </button>

                                  <div>
                                    <span className="label italic label-icon-format mb-0">
                                      Formatos: .png, .jpg, .jpeg
                                    </span>
                                  </div>
                                  <div>
                                    <span className="label italic label-icon-format">
                                      Dimensão: 80x80px
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="container-tamanho-icone">
                                Tamanho do ícone
                                <div className="container-valor-tamanho-icon">
                                  <div
                                    className={
                                      Number(channel.settings.iconSize) === 55
                                        ? 'activeFont'
                                        : ''
                                    }
                                    onClick={() => this.tamIconFunc(55)}
                                    role="button"
                                    tabIndex={0}
                                  >
                                    55
                                  </div>
                                  <div
                                    className={
                                      Number(channel.settings.iconSize) === 60
                                        ? 'activeFont'
                                        : ''
                                    }
                                    onClick={() => this.tamIconFunc(60)}
                                    role="button"
                                    tabIndex={0}
                                  >
                                    60
                                  </div>
                                  <div
                                    className={
                                      Number(channel.settings.iconSize) === 70
                                        ? 'activeFont'
                                        : ''
                                    }
                                    onClick={() => this.tamIconFunc(70)}
                                    role="button"
                                    tabIndex={0}
                                  >
                                    70
                                  </div>
                                  <div
                                    className={
                                      Number(channel.settings.iconSize) === 80
                                        ? 'activeFont'
                                        : ''
                                    }
                                    onClick={() => this.tamIconFunc(80)}
                                    role="button"
                                    tabIndex={0}
                                  >
                                    80
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-5">
                              <div>
                                <span className="label">Cores</span>
                              </div>
                              <div className="div-cor">
                                <button
                                  className="circle"
                                  style={{
                                    backgroundColor: channel.settings.mainColor,
                                  }}
                                  data-toggle="modal"
                                  data-target="#colorModal"
                                  onClick={() => {
                                    this.onOpenColorPicker('main');
                                  }}
                                  type="button"
                                />
                                <span className="label lable-color mb-0-cor">
                                  Cor Principal
                                </span>
                              </div>
                              <div className="div-cor">
                                <button
                                  className="circle"
                                  style={{
                                    backgroundColor:
                                      channel.settings.secondaryColor,
                                  }}
                                  data-toggle="modal"
                                  data-target="#colorModal"
                                  onClick={() => {
                                    this.onOpenColorPicker('secondary');
                                  }}
                                  type="button"
                                />
                                <span className="label lable-color mb-0-cor">
                                  Cores Secundárias
                                </span>
                              </div>

                              <div className="div-cor">
                                <button
                                  className="circle"
                                  style={{
                                    backgroundColor:
                                      channel.settings.mainTextColor,
                                  }}
                                  data-toggle="modal"
                                  data-target="#colorModal"
                                  onClick={() => {
                                    this.onOpenColorPicker('textMain');
                                  }}
                                  type="button"
                                />
                                <span className="label lable-color mb-0-cor">
                                  Cor do texto principal
                                </span>
                              </div>

                              <div className="div-cor">
                                <button
                                  className="circle"
                                  style={{
                                    backgroundColor:
                                      channel.settings.secondaryTextColor,
                                  }}
                                  data-toggle="modal"
                                  data-target="#colorModal"
                                  onClick={() => {
                                    this.onOpenColorPicker('textSecondary');
                                  }}
                                  type="button"
                                />
                                <span className="label lable-color mb-0-cor">
                                  Cor do texto Secundárias
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <span className="label">
                                  Domínios do bot (opcional)
                                </span>
                                <input
                                  disabled={
                                    !!(
                                      user?.selectedCompany?.claim?.name ===
                                      'Viewer'
                                    )
                                  }
                                  type="text"
                                  className="form-control setup-input"
                                  defaultValue={channel.settings.domains}
                                  onChange={(event) =>
                                    this.updateChannelDomain(event.target.value)
                                  }
                                  placeholder="www.exemplo.top.flexcontact; www.exemplo.top.flexcontact"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-1">
                              <div
                                className="float-left"
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Toggle
                                  disabled={
                                    !!(
                                      user?.selectedCompany?.claim?.name ===
                                      'Viewer'
                                    )
                                  }
                                  checked={
                                    channel
                                      ? channel.isNotificationSound
                                      : false
                                  }
                                  onChange={this.onChaneActiveNotificationSound}
                                  identifier="active-sound"
                                />
                                <div style={{ marginTop: 8, width: 200 }}>
                                  <span>
                                    {i18n.t('Ativar notificação sonora')}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-12">
                              <div
                                className="float-left"
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Toggle
                                  disabled={
                                    !!(
                                      user?.selectedCompany?.claim?.name ===
                                      'Viewer'
                                    )
                                  }
                                  checked={channel ? channel.isActive : false}
                                  onChange={this.onChannelActiveChanged}
                                  identifier="active-channel"
                                />
                                <div style={{ marginTop: 8, width: 200 }}>
                                  <span>{i18n.t('Ativar canal')}</span>
                                </div>
                              </div>
                              <div className="float-right">
                                <button
                                  className="btn btn-primary"
                                  disabled={
                                    !!(
                                      user?.selectedCompany?.claim?.name ===
                                      'Viewer'
                                    )
                                  }
                                  onClick={() => this.updateChannel(channel)}
                                  type="button"
                                >
                                  {i18n.t('salvar')}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Tab Publicação */}
                        <div className="tab-pane" role="tabpanel" id="tab-2">
                          <div className="row">
                            <div className="col-md-2 pl-0">
                              <img
                                className="setup-icon"
                                alt="Bot icon"
                                src={channel.settings.botFab}
                              />
                            </div>
                            <div className="col-md-10">
                              <p className="mt-3">
                                Adicione os arquivos javascript, CSS e o script
                                conforme o exemplo abaixo na sua página web.
                              </p>
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-md-12">
                              <div>
                                <pre className="setup-code">
                                  <code
                                    id="code-text"
                                    className="language-javascript"
                                  >
                                    {this.code}
                                  </code>
                                </pre>
                                {
                                  /* Logical shortcut for only displaying the
                                    button if the copy command exists */
                                  document.queryCommandSupported('copy') && (
                                    <div>
                                      <button
                                        onClick={this.copyToClipboard}
                                        style={{
                                          float: 'right',
                                          paddingRight: '0px',
                                        }}
                                        className="btn btn-default btn-copy js-tooltip js-copy"
                                        data-toggle="tooltip"
                                        type="button"
                                      >
                                        <svg
                                          className="icon_copy"
                                          xmlns="http://www.w3.org/2000/svg"
                                          version="1.1"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                        >
                                          <path d="M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" />
                                        </svg>
                                      </button>
                                      {copySuccess}
                                    </div>
                                  )
                                }
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12 button-setup-save">
                              <Link
                                to={`/webchat/${botid}`}
                                target="_blank"
                                className="btn-config-webchat"
                                style={{
                                  paddingLeft: '20px!important',
                                  paddingRight: '20px!important',
                                }}
                              >
                                Acesse seu bot
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Bot preview */}
              <div className="col-md-4">
                <span className="channel-subtitle">
                  {i18n.t('Pré visualização')}
                </span>

                <div
                  id="bot-widget-chat-faq"
                  className=""
                  style={{ marginTop: 8 }}
                >
                  <div
                    id="bot-widget-chat-header"
                    style={{
                      backgroundColor: channel.settings.mainColor || mainColor,
                    }}
                  >
                    <span
                      id="bot-widget-chat-header-name"
                      style={{
                        color: channel.settings.mainTextColor || mainTextColor,
                      }}
                    >
                      {name || channel.settings.headerName}
                    </span>
                  </div>
                  <div className="bot-widget-chat-wrap">
                    <div className="bot-widget-chat-messages">
                      <div className="bot-widget-chat-message-container">
                        <div
                          className="bot-widget-chat-message"
                          style={{
                            backgroundColor:
                              channel.settings.secondaryColor || secondaryColor,
                            color:
                              channel.settings.secondaryTextColor ||
                              secondaryTextColor,
                          }}
                        >
                          <p>
                            E ai, tudo certo? Tô aqui pra te ajudar, qual teu
                            nome?
                          </p>
                        </div>
                      </div>
                      <div className="bot-widget-chat-message-container-user">
                        <div
                          className="bot-widget-chat-message-user"
                          style={{
                            backgroundColor:
                              channel.settings.mainColor || mainColor,
                            color:
                              channel.settings.mainTextColor || mainTextColor,
                          }}
                        >
                          Alex
                        </div>
                      </div>
                    </div>
                    <div className="bot-widget-chat-footer">
                      <img alt="Anexo" src={iconAttachment} />
                      <div className="bot-widget-chat-input-container">
                        <input
                          disabled={
                            !!(user?.selectedCompany?.claim?.name === 'Viewer')
                          }
                          placeholder="Digite sua mensagem"
                          maxLength={1000}
                        />
                        <div>
                          <img alt="Message" src={iconSendMessage} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="channel-widget-html-fab">
                  <ChannelBarFab
                    tamIcon={Number(channel.settings.iconSize)}
                    channel={channel}
                    isChannel={isChannel}
                  />
                </div>
              </div>
            </div>
            {/* Color Modal */}
            <div
              className="modal fade"
              id="colorModal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalCenterTitle"
              aria-hidden="true"
            >
              <div
                className="modal-dialog-color modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content-color modal-content">
                  <div className="modal-body">
                    <SketchPicker
                      color={pickerColor}
                      onChangeComplete={(color) =>
                        this.onPickerColorChanged(color)
                      }
                    />
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-dismiss="modal"
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators, ...UserActions }, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ChannelWidgetHtml))
);
